import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeSevenComponent } from './components/home-seven/home-seven.component';

const routes: Routes = [
    {path: '', component: HomeSevenComponent},
    {path: 'home', component: HomeSevenComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
